/* Instant swipe for product carousel */
(function() {
  function makeInstant() {
    var sliders = document.querySelectorAll('.f-product__media-list');
    sliders.forEach(function(el) {
      var flkty = window.FoxTheme && window.FoxTheme.Flickity && window.FoxTheme.Flickity.data(el);
      if (!flkty) {
        // Try getting it from the slider component
        var comp = el.closest('flickity-component') || el;
        if (comp.slider && comp.slider.instance) flkty = comp.slider.instance;
      }
      if (flkty) {
        flkty.options.selectedAttraction = 0.2;
        flkty.options.friction = 0.8;
        flkty.options.freeScrollFriction = 0.075;
      }
    });
  }
  // Run after page load and after any media init
  document.addEventListener('DOMContentLoaded', function() { setTimeout(makeInstant, 500); });
  document.addEventListener('product-media:loaded', function() { setTimeout(makeInstant, 200); });
  // Also run on window load as fallback
  window.addEventListener('load', function() { setTimeout(makeInstant, 300); });
})();
